import { collectCounters } from './countersHelper';
import getPageLang from './getPageLang';

const SimpleValidator = {
    isEmpty(str) {
        return str.length <= 0;
    },

    isNotPhoneNumber(str) {
        // +8999500555 or 8999500555
        const onlyNumbers = /^[+]?[0-9]+$/;
        return !onlyNumbers.test(str);
    },

    isOnlyNumericInput(keyPressed) {
        const keysAllowed = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '+',
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Tab',
            'Enter',
        ];
        return !keysAllowed.includes(keyPressed);
    },
};

function amoFormSettings() {
    /* eslint-disable camelcase */
    const { utm_source, utm_medium, utm_campaign, utm_term } = JSON.parse(localStorage.umnico_utm || '{}');
    const { googleClientId, roistatVisit, yandexClientId } = collectCounters();

    return {
        url: 'https://wdg.biz-crm.ru/inserv/in.php',
        headers: {
            'Content-Type': 'text/plain',
        },
        payload: {
            client: 'mastinvest',
            type: `web_inquiry_${getPageLang()}`,
            roistat: roistatVisit,
            yclid: yandexClientId,
            gclid: googleClientId,
            page_url: window.location.href,
            utm_source,
            utm_medium,
            utm_campaign,
            utm_term,
        },
    };
}

export { amoFormSettings, SimpleValidator };
